import { useCurrentUser } from 'api';
import defaultLogo from 'assets/safi.png';
import { Header, Omnisearch, UserMenu } from 'features';
import { logger } from 'monitor';
import { Link } from 'react-router-dom';
import { Box, Button, IconButton, Skeleton, Stack, useBreakpoint } from 'ui';
import { Menu } from 'ui/icons';

export const HEADER_HEIGHT = 8;

const HeaderLogo = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <Box
      sx={(theme) => ({
        alignItems: 'center',
        display: 'flex',
        ...(!isMobile && {
          left: '50%',
          position: 'absolute',
          transform: 'translateX(-50%)',
        }),
        ...(isMobile && {
          left: theme.spacing(HEADER_HEIGHT),
          position: 'absolute',
        }),
      })}
    >
      <img src={defaultLogo} alt="Safi logo" height="31px" />
    </Box>
  );
};

export const HeaderLinks = () => {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return <Skeleton variant="rounded" width={100} height={35} />;
  }

  if (user?.is_superuser) {
    return (
      <Stack direction="row" gap={1}>
        <Button variant="secondary" component={Link} to="/ground-control/">
          Ground Control
        </Button>
        <Button variant="secondary" component="a" href="/post-deal/dealhub/">
          DealHub
        </Button>
      </Stack>
    );
  }

  if (user?.is_buyer) {
    return (
      <Button variant="secondary" component="a" href="/shipments/">
        Shipments
      </Button>
    );
  }

  if (user?.is_seller) {
    return (
      <Stack direction="row" gap={1}>
        <Button variant="secondary" component="a" href="/deals/">
          Deals
        </Button>
        <Button variant="secondary" component="a" href="/collections/">
          Collections
        </Button>
      </Stack>
    );
  }
  logger.error('Unable to determine user type when rendering HeaderLinks');
  return null;
};

export const InternalHeader = ({ onMenuClick }: { onMenuClick: () => void }) => {
  const { isMobile } = useBreakpoint();
  return (
    <Header>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton aria-label="open sidebar" onClick={onMenuClick}>
          <Menu />
        </IconButton>
        {!isMobile && <HeaderLinks />}
      </Stack>

      <HeaderLogo isMobile={isMobile} />

      <Stack direction="row" alignItems="center" gap={1}>
        <Omnisearch />

        <UserMenu />
      </Stack>
    </Header>
  );
};
